<mat-card class="py-5 px-5">
  <mat-card-title-group class="d-flex align-items-center mb-3">
    <mat-card-title>
      <h5 class="my-2">{{ site.name }}</h5>
    </mat-card-title>
    <div *ngIf="!readOnly">
      <button mat-icon-button color="primary" (click)="edit()">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button color="warn" (click)="delete()">
        <mat-icon>delete_foerver</mat-icon>
      </button>
    </div>
  </mat-card-title-group>

  <mat-card-content>
    <div>
      <p class="sub-title">{{ TITLE + "SITE_DESCRIPTION" | translate }}</p>

      <!--
        <div *ngFor="let d of site.description | keyvalue" class="description">
          {{ getLangNameByCode(d.key) }}: {{ d.value }}
        </div>
      -->

      <span>{{ site.description["hun"] }}</span>
    </div>
    <ng-container *ngIf="showMoreActive">
      <div>
        <p class="sub-title">{{ TITLE + "MERCHANT_TYPES" | translate }}</p>
        <div class="d-flex flex-wrap gap-3">
          <app-status-chip
            *ngFor="
              let t of site.merchantTypes | sortMerchantTypes: 'merchantType'
            "
            [status]="t.status"
            [label]="'MERCHANT.TYPE.' + t.merchantType | translate"
            [matTooltip]="
              t.status !== 'ACCEPTED' ? ('STATUS.' + t.status | translate) : ''
            "
          ></app-status-chip>
        </div>
      </div>

      <div>
        <p class="sub-title">{{ TITLE + "SITE_TYPES" | translate }}</p>
        <div class="d-flex flex-wrap gap-3">
          <app-status-chip
            *ngFor="let t of site.types"
            [status]="'ACCEPTED'"
            [label]="'MERCHANT.SITE_TYPE.' + t | translate"
          ></app-status-chip>
        </div>
      </div>
    </ng-container>

    <div>
      <p class="sub-title">{{ TITLE + "CONTACT" | translate }}</p>
      <div>
        <span>{{ TITLE + "ADDRESS" | translate }}: </span>
        <span
          >{{ site.address.zipCode }} {{ site.address.city }}
          {{ site.address.streetName }} {{ site.address.streetType }}
          {{ site.address.number }} {{ site.address.building }}
          {{ site.address.stairs }} {{ site.address.floor
          }}{{ site.address.door }}</span
        >
      </div>
      <div>
        <span>{{ TITLE + "PHONE" | translate }}: </span>
        <span>{{ site.phone | telephoneFormat }}</span>
      </div>
    </div>

    <ng-container *ngIf="showMoreActive">
      <div>
        <p class="sub-title">{{ TITLE + "OPENING_HOURS" | translate }}</p>
        <div class="table-container">
          <table>
            <caption></caption>
            <th></th>
            <tr *ngFor="let day of openingHours">
              <td>{{ DAYS + day.day | uppercase | translate }}:</td>
              <td class="ms-4 d-flex">
                <span *ngIf="!day.opening">
                  {{ false | yesNo | translate }}
                </span>
                <span *ngIf="day.opening">
                  {{ day.opening.from }} -
                  {{ day.opening.to }}
                </span>
              </td>
            </tr>
            <span *ngIf="!site.openingHours"> - </span>
          </table>
        </div>
      </div>

      <div>
        <p class="sub-title">
          {{ TITLE + "DELIVERY_SERVICE_AVAILABLE" | translate }}
        </p>
        <span
          *ngIf="
            !site.deliveryServiceAvailable;
            else hasDeliveryServiceAvailable
          "
        >
          -
        </span>
        <ng-template #hasDeliveryServiceAvailable>
          <div class="d-flex flex-wrap gap-3">
            <app-status-chip
              *ngFor="let t of site.deliveryServiceFor"
              [status]="t.status"
              [label]="
                'MERCHANT.CUSTOMER_SEGMENT.' + t.customerSegment | translate
              "
            ></app-status-chip>
          </div>
        </ng-template>
      </div>

      <div>
        <p class="sub-title">
          {{ TITLE + "ON_SITE_SERVICE_AVAILABLE" | translate }}
        </p>
        <span
          *ngIf="!site.onSiteServiceAvailable; else hasOnSiteServiceAvailable"
        >
          -
        </span>
        <ng-template #hasOnSiteServiceAvailable>
          <div class="d-flex flex-wrap gap-3">
            <app-status-chip
              *ngFor="let t of site.onSiteServiceFor"
              [status]="t.status"
              [label]="
                'MERCHANT.CUSTOMER_SEGMENT.' + t.customerSegment | translate
              "
            ></app-status-chip>
          </div>
        </ng-template>
      </div>

      <div>
        <p class="sub-title">
          {{ TITLE + "UNPACKAGED_PRODUCTS_AVAILABLE" | translate }}
        </p>
        <span>
          {{ site.unpackagedProductsAvailable | yesNo | translate }}
        </span>
      </div>
    </ng-container>

    <button
      class="show-btn"
      mat-stroked-button
      color="primary"
      (click)="showMoreActive = !showMoreActive"
    >
      {{
        (showMoreActive ? "MERCHANT.BTN.SHOW_LESS" : "MERCHANT.BTN.SHOW_MORE")
          | translate
      }}
    </button>
  </mat-card-content>
</mat-card>
